import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "279",
  "slug": "spot-indonesia-from-satellite-imagery",
  "title": "How to Recognise Indonesia in Satellite Images",
  "excerpt": "Indonesia spans a long island chain between the Indian and Pacific oceans.",
  "date": "2026-04-20",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/indonesia.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Indonesia spans a long island chain between the Indian and Pacific oceans. Sumatra and Java have elongated shapes, while Sulawesi branches into several peninsulas. In mountainous islands, ridges and volcanic cones can divide narrow coastal lowlands from the interior."
    },
    {
      "type": "heading",
      "text": "Island chains and volcanic ridges"
    },
    {
      "type": "paragraph",
      "text": "Compare the outlines of Java and Sulawesi. Then examine a coastal section to see how much of that island-scale shape remains visible after zooming in."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "The Philippines also has volcanic islands and tropical vegetation. Borneo is shared with Malaysia and Brunei, and New Guinea with Papua New Guinea. An island shape can identify the landmass without determining which country contains a close-up location."
    }
  ],
  "imageAlt": "Indonesia regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
